import React, { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { Button, Flex, Form, Input, Modal } from "antd";

const ShareFile = ({ shareFileOpen, setShareFileOpen, shareData, shareLink, setShareLink }) => {
    const notify = (error) => toast.error(error);
    const notifySuccess = (msg) => toast.success(msg);
    const [copyClip, setCopyClip] = useState(false)

    const shareFileFun = () => {
        const link = shareData.getFieldValue("folder_name");
        if (link) {
            navigator.clipboard.writeText(link)
                .then(() => {
                    // console.log("Link copied to clipboard!");
                    notifySuccess("Link copied to clipboard!")
                    setCopyClip(true)
                    setShareFileOpen(false)
                })
                .catch((err) => {
                    console.error("Failed to copy: ", err);
                });
        }
    }

    useEffect(() => {
        if (shareFileOpen && shareLink) {
            shareData.setFieldsValue({ folder_name: shareLink });
            setCopyClip(false)
        }
    }, [shareFileOpen, shareLink]);

    return (
        <>
            < Modal title={"File Share Link"} open={shareFileOpen} className="bd_model_main shareModal"
                onCancel={() => { setShareFileOpen(false); shareData.resetFields(); setCopyClip(false); setShareLink("") }}
                footer={null}
            >
                <Form name="validateOnly" layout="vertical" autoComplete="off" form={shareData} initialValues={{ folder_name: shareLink }}>
                    <div className='bd_model_input'>
                        <Form.Item label="Link" name="folder_name">
                            <Input type="text" value={shareLink} disabled={true} />
                        </Form.Item>
                    </div>

                    <Flex justify='flex-end' align='center'>
                        {/* <Button key="back" className='BG_ghostButton' onClick={() => renameFolder.resetFields()}>
                            Reset
                        </Button> */}
                        <Button key="submit" className='BG_mainButton' style={{ marginLeft: '20px' }} disabled={copyClip} onClick={() => shareFileFun()} type="primary" htmlType="submit">
                            {copyClip ? "Copied" : "Copy Link"}
                        </Button>
                    </Flex>
                </Form>
            </Modal >
        </>
    )
}

export default ShareFile;